//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast} from "vant";
import global from '../../../static/js/global.js'
export default {
  components: {
    [Toast.name]: Toast
  },
  data() {
    return {
      arr: [],
      num: [0,0,0,0],
      openId: ""
    };
  },
  mounted() {
    this.openId = this.$router.history.current.query.openid;
    this.getAuthCode();
  },
  methods: {
    getAuthCode(){
        this.$http.get(global.host + 'guardCard/visitorAuthCode?openid='+this.openId).then(function(res){
            console.log("res   ===   "+JSON.stringify(res));
            if(res.body.code == "200"){
                if(res.body.data){
                    this.num = res.body.data.split('');
                }
            } else {
                Toast.fail({
                  message: res.body.message,
                  duration: 3000
                });
            }
        },function(err){
            Toast.fail({
              message: '服务异常，请稍后重试',
              duration: 3000
            });
        })
    },
    randomNum() {
      var i = 0,
        j = 0;
      for (let i = 0; i < 18; i++) {
        this.arr[i] = Math.floor(Math.random() * 10); //获取到随机数
      }
      for (i; i < this.arr.length; i++) {
        for (j = i + 1; j < this.arr.length; j++) {
          if (this.arr[i] == this.arr[j]) {
            this.arr.splice(j, 1);
            j--;
          }
        }
      }
      this.num = this.arr.slice(0, 4);
      console.log("截取", this.num);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/accessControl/visitorAuthCode.vue